export const DEFAULT_PERIOD = "2026-W09";

export const DEFAULT_PARAMETERS = {
  contractHours: 176,
  operatorCount: 22,
  productivityAvg: 10.5,
  maintenanceHours: 18,
  lossesPercent: 6,
  riskFactor: 8,
  tolerancePercent: 3,
};

export const DEFAULT_FILTERS = {
  site: "all",
  line: "all",
  riskLevel: "all",
  status: "all",
  machineQuery: "",
  onlyBottlenecks: false,
};

export const DEFAULT_LAYOUT = {
  groupBy: "machine",
  visibleColumns: [
    "label",
    "site",
    "line",
    "plan",
    "simulated",
    "realized",
    "attendancePct",
    "gap",
    "status",
    "bottleneck",
  ],
};

export const DEFAULT_PREFERENCES = {
  compareScenarioId: null,
};

export const RESULT_COLUMNS = [
  { key: "label", label: "Item" },
  { key: "period", label: "Período" },
  { key: "site", label: "UP" },
  { key: "line", label: "Linha" },
  { key: "riskLevel", label: "Risco" },
  { key: "plan", label: "Plano" },
  { key: "simulated", label: "Simulado" },
  { key: "realized", label: "Realizado" },
  { key: "attendancePct", label: "% Atendimento" },
  { key: "gap", label: "Gap/Folga" },
  { key: "status", label: "Status" },
  { key: "bottleneck", label: "Gargalo" },
];

export const GROUP_BY_OPTIONS = [
  { value: "machine", label: "Por máquina" },
  { value: "period", label: "Por período" },
  { value: "bottleneck", label: "Por gargalo" },
  { value: "risk", label: "Por risco" },
];

export const STORAGE_KEYS = {
  scenarios: "simulador_workbench_scenarios_v1",
  activeScenarioId: "simulador_workbench_active_scenario_v1",
  executionHistory: "simulador_workbench_execution_history_v1",
  preferences: "simulador_workbench_preferences_v1",
  views: "simulador_workbench_views_v1",
  activeViewId: "simulador_workbench_active_view_v1",
  baseMachines: "simulador_workbench_base_machines_v4",
  baseTeams: "simulador_workbench_base_teams_v4",
  baseMaintenance: "simulador_workbench_base_maintenance_v4",
  baseTeamAbsences: "simulador_workbench_base_team_absences_v4",
  baseTeamBoosts: "simulador_workbench_base_team_boosts_v4",
  baseContractHoursCalendar: "simulador_workbench_base_contract_hours_calendar_v4",
};

export function cloneDefaultParameters() {
  return { ...DEFAULT_PARAMETERS };
}

export function cloneDefaultFilters() {
  return { ...DEFAULT_FILTERS };
}

export function cloneDefaultLayout() {
  return {
    ...DEFAULT_LAYOUT,
    visibleColumns: [...DEFAULT_LAYOUT.visibleColumns],
  };
}
